import { Injectable } from '@angular/core'
import { WindowRef } from '@spartacus/core'

@Injectable({
  providedIn: 'root'
})
export class MbDocumentService {

  constructor (private winRef: WindowRef) {
  }

  querySelector (selector: string = ''): Element | null {
    return this.winRef.document.querySelector(selector)
  }

  getElementById (id: string = ''): HTMLElement | null {
    return this.winRef.document.getElementById(id)
  }

  querySelectorAll (selector: string = ''): NodeListOf<HTMLElement> {
    return this.winRef.document.querySelectorAll(selector)
  }

  getActiveElement (): Element | null {
    return this.winRef.document.activeElement
  }

  getElementsByTagName (tagName: string = ''): HTMLCollectionOf<Element> | null {
    return this.winRef.document.getElementsByTagName(tagName)
  }

  createScriptElement (): HTMLScriptElement {
    return this.winRef.document.createElement('script')
  }
}
